import { css } from '@emotion/react';
import type { ReactElement } from 'react';

import { styled } from '../../../../styled';
import type { Theme } from '../../../../theme/interface/detailed';
import { useTheme } from '../../../../theme/useTheme';

type Interface = { className: string };

const Component = ({ className }: Interface): ReactElement => {
	const theme = useTheme();

	return (
		<div className={className}>
			<svg className="outline" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
				<g
					clipPath="url(#a)"
					stroke={theme.chat.icons.pendingMessageIcon.fill}
					strokeWidth="1.6"
					strokeLinecap="round"
					strokeLinejoin="round"
				>
					<path d="M5 9.375a4.375 4.375 0 1 0 0-8.75 4.375 4.375 0 0 0 0 8.75Z" />
					<path d="M5 2.813V5l1.563.938" />
				</g>
				<defs>
					<clipPath id="a">
						<path fill={theme.chat.icons.pendingMessageIcon.fill} d="M0 0h10v10H0z" />
					</clipPath>
				</defs>
			</svg>
		</div>
	);
};
const PendingMessageIcon = styled(Component)(
	({
		theme: {
			chat: {
				icons: {
					// eslint-disable-next-line @typescript-eslint/no-unused-vars
					pendingMessageIcon: { size, ...others },
				},
			},
		},
	}: {
		theme: Theme;
	}) => others,
	({ theme }: { theme: Theme }) => css`
		height: ${theme.chat.icons.pendingMessageIcon.size};
		margin-left: 9px;
		position: relative;
		width: ${theme.chat.icons.pendingMessageIcon.size};

		& > svg {
			bottom: -2px;
			left: 0;
			position: absolute;
		}
	`
);

export { PendingMessageIcon };
